var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "sticky-container",
          attrs: { "body-style": { padding: 0 }, shadow: "never" },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "el-row",
                { staticClass: "filter-container" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "danger", icon: "el-icon-edit" },
                          on: { click: _vm.handleCreate },
                        },
                        [_vm._v("增加分类")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                { name: "sticky-header", rawName: "v-sticky-header" },
              ],
              attrs: {
                stripe: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
                "row-key": "id",
                "header-cell-class-name": "table-header-cell",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "60",
                  align: "center",
                  type: "index",
                  fixed: "left",
                },
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: "分类名称",
                    prop: "name",
                    "min-width": "150",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "span",
                            {
                              staticStyle: { "font-weight": "600" },
                              style: { color: row.color },
                            },
                            [_vm._v(_vm._s(row.name))]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_vm._v('" ')]
              ),
              _c("el-table-column", {
                attrs: { label: "所属商城", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getMallType(row.mallType))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "在首页显示", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: row.showInHome === 1 ? "success" : "info",
                              effect: "dark",
                            },
                          },
                          [_vm._v(_vm._s(row.showInHome === 1 ? "是" : "否"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排序",
                  prop: "sortOrder",
                  width: "60",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: row.status === 1 ? "success" : "info",
                              effect: "dark",
                            },
                          },
                          [_vm._v(_vm._s(row.status === 1 ? "启用" : "禁用"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "230" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleCreate(row)
                              },
                            },
                          },
                          [_vm._v("添加下级分类")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleRemove(row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogFormTitle,
            visible: _vm.dialogFormVisible,
            width: "500px",
            fullscreen: _vm.device === "mobile",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticStyle: { padding: "0 25px" },
              attrs: {
                rules: _vm.rules,
                model: _vm.detail,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "上级分类", prop: "parentId" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.categories,
                      props: {
                        value: "id",
                        label: "name",
                        checkStrictly: true,
                      },
                    },
                    model: {
                      value: _vm.detail.parentId,
                      callback: function ($$v) {
                        _vm.$set(_vm.detail, "parentId", $$v)
                      },
                      expression: "detail.parentId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分类名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入分类名称", clearable: "" },
                    model: {
                      value: _vm.detail.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.detail, "name", $$v)
                      },
                      expression: "detail.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所属商城" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择商城" },
                      model: {
                        value: _vm.detail.mallType,
                        callback: function ($$v) {
                          _vm.$set(_vm.detail, "mallType", $$v)
                        },
                        expression: "detail.mallType",
                      },
                    },
                    _vm._l(_vm.mallTypes, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item, value: index },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-between" } },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "字体颜色" } },
                        [
                          _c("el-color-picker", {
                            model: {
                              value: _vm.detail.color,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "color", $$v)
                              },
                              expression: "detail.color",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序" } },
                        [
                          _c("el-input", {
                            staticClass: "max-width",
                            attrs: {
                              placeholder: "请输入排列顺序",
                              type: "number",
                            },
                            model: {
                              value: _vm.detail.sortOrder,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "sortOrder", $$v)
                              },
                              expression: "detail.sortOrder",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "在首页显示" } },
                        [
                          _c("el-switch", {
                            staticClass: "rectangle",
                            attrs: {
                              width: 60,
                              "active-value": 1,
                              "inactive-value": 0,
                            },
                            model: {
                              value: _vm.detail.showInHome,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "showInHome", $$v)
                              },
                              expression: "detail.showInHome",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "启用" } },
                        [
                          _c("el-switch", {
                            staticClass: "rectangle",
                            attrs: {
                              width: 60,
                              "active-value": 1,
                              "inactive-value": 0,
                            },
                            model: {
                              value: _vm.detail.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "status", $$v)
                              },
                              expression: "detail.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("提交保存")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }